// Short, human-readable summary of a pricing template's rule.
//
// Templates store a positive magnitude in reduction_value and the direction in a
// separate reduction_direction field (1 = low/reduce, -1 = high/raise). Read the
// field directly; never infer direction from the sign of the magnitude.
export const templateRuleSummary = (template, t) => {
  if (!template) return "";
  const value = template.reduction_value === null || template.reduction_value === undefined
    ? 0 : template.reduction_value;
  const dir = template.reduction_direction === -1 ? t('reprice.high') : t('reprice.low');
  const valStr = template.reduction_type === 'ratio' ? '%' + Math.abs(value) : Math.abs(value);
  return dir + ' · ' + valStr;
};
